(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("element-ui"), require("cb-components-common"), require("vuex"));
	else if(typeof define === 'function' && define.amd)
		define("cb-components-suitability", ["element-ui", "cb-components-common", "vuex"], factory);
	else if(typeof exports === 'object')
		exports["cb-components-suitability"] = factory(require("element-ui"), require("cb-components-common"), require("vuex"));
	else
		root["cb-components-suitability"] = factory(root["ELEMENT"], root["cb-components-common"], root["Vuex"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_element_ui__, __WEBPACK_EXTERNAL_MODULE_cb_components_common__, __WEBPACK_EXTERNAL_MODULE_vuex__) {
return 